import axios from "axios";
import { clearSession } from "../utils/clearSession";

const baseURL = process.env.REACT_APP_JUSTTAWK_IND_BASE_API_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Keeps saved preferences (e.g. lead pipeline filters) through an expired session
      clearSession();
      const currentPath = window.location.pathname;
      if (currentPath.startsWith("/agent")) {
        window.location.href = "/agent/login";
      } else if (currentPath.startsWith("/admin")) {
        window.location.href = "/admin/login";
      } else {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

axiosInstance.isCancel = axios.isCancel;
axiosInstance.CancelToken = axios.CancelToken;

export default axiosInstance;
